import { Component, inject, OnInit } from '@angular/core';
import {
  BrowserMessagesService,
  LoaderComponent,
  SideMenuHeadlineComponent,
  TableColumn, TableComponent
} from '@rbb/ng-web-template-lib';
import { Form } from '../../data/form';
import { uniq } from 'lodash';
import { FormService } from '../../services/form.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-admin-forms',
  imports: [
    DatePipe,
    LoaderComponent,
    SideMenuHeadlineComponent,
    TableComponent
  ],
  templateUrl: './admin-forms.component.html',
  styleUrl: './admin-forms.component.css'
})
export class AdminFormsComponent implements OnInit {
  private browserMessagesService = inject(BrowserMessagesService);
  private formService = inject(FormService);

  forms: Form[] | undefined;
  columns: TableColumn[] | undefined;

  ngOnInit(): void {
    this.getForms();
  }

  getForms(): void {
    this.formService.getForms().subscribe({
      next: (next) => {
        this.forms = next;
        this.columns = [
          { name: 'Kategorie', field: 'groupName', type: 'string', selections: uniq(next.map(form => form.groupName)).filter(s => s).sort().map(groupName => ({ name: groupName!, value: groupName! })) },
          { name: 'Name', field: 'name', type: 'string' },
          { name: 'letzter Bearbeiter', field: 'createdByLastName', type: 'string' },
          { name: 'zuletzt bearbeitet', field: 'timestamp', type: 'Date' },
          { name: 'Datenschutz', field: 'approvalDataProtectionOfficer', type: 'string', selections: [
            { name: 'Ok', value: 'APPROVED' },
            { name: 'Abgelehnt', value: 'DECLINED' },
            { name: 'Warte auf Freigabe', value: 'PENDING' }
          ] },
          { name: 'Sichtbar', field: 'visible', type: 'boolean' },
          { name: 'Tag', field: 'tag', type: 'string' },
          { name: 'Gruppen', field: 'visibleForGroups', type: 'string[]' },
          { name: 'Besitzer', field: 'owner', type: 'string[]' },
          { name: 'Bearbeiter', field: 'operators', type: 'string[]' },
          { name: 'Leser', field: 'readers', type: 'string[]' },
          { name: 'Tester', field: 'tester', type: 'string[]' },
          { name: 'Letzter Bearbeiter', field: 'showLastOperator', type: 'boolean' },
          { name: 'Stornierung möglich', field: 'allowCancelUntilProgressStarts', type: 'boolean' },
          { name: 'Genehmigungsweg', field: 'approverTypes', type: 'string[]' },
          { name: 'Genehmigungsdaten', field: 'approverData', type: 'string' },
          { name: 'Genehmigungsreihenfolge', field: 'orderedApprovals', type: 'boolean' },
          { name: 'Aktion', field: 'actionType', type: 'string' },
          { name: 'Aktionsdaten', field: 'actionData', type: 'string' },
          { name: 'Felder', field: 'fields', type: null },
          { name: 'Org Unit Typ', field: 'orgUnitType', type: 'string' },
          { name: 'Org Unit Name', field: 'orgUnitName', type: 'string' },
          { name: 'E-Mail', field: 'contactEmail', type: 'string' },
          { name: 'Telefon', field: 'contactTelephone', type: 'string' },
          { name: 'Speicherdauer', field: 'storagePeriod', type: 'number' }
        ];
      },
      error: error => this.browserMessagesService.showHttpError(error, 'Formulare konnten nicht geladen werden')
    });
  }
}
